<template>
  <v-card class="rounded-xl elevation-2 border-0 overflow-hidden mb-6 dashboard-card">
    <v-card-title class="d-flex justify-space-between align-center px-6 pt-6 pb-2">
      <div>
        <div class="text-overline font-weight-black primary--text mb-n1">{{ subtitulo }}</div>
        <div class="text-h5 font-weight-black deep-blue--text">{{ titulo }}</div>
      </div>
      <v-avatar color="primary lighten-5" size="48">
        <v-icon color="primary">mdi-chart-line-variant</v-icon>
      </v-avatar>
    </v-card-title>

    <v-sheet color="transparent" class="px-2">
      <v-sparkline
        :key="valores.length + valores.join('')"
        :value="valores"
        :labels="etiquetas"
        color="primary"
        line-width="2"
        padding="24"
        smooth="10"
        auto-draw
        stroke-linecap="round"
        fill
        gradient-direction="top"
        :gradient="['#4318FF', '#4318FF05']"
      >
        <template v-slot:label="item">
          <tspan class="chart-label">{{ item.value }}</tspan>
        </template>
      </v-sparkline>
    </v-sheet>

    <v-card-actions class="px-4 pb-6 pt-0">
      <v-slide-group show-arrows>
        <v-slide-item v-for="(valor, i) in valores" :key="i">
          <div class="ma-2 pa-3 rounded-lg grey lighten-4 text-center min-width-data">
            <div class="caption font-weight-bold grey--text text-uppercase">{{ etiquetas[i] || '-' }}</div>
            <div class="text-subtitle-2 font-weight-black deep-blue--text">
              {{ esMoneda ? 'S/ ' + valor : valor }}
            </div>
          </div>
        </v-slide-item>
      </v-slide-group>
    </v-card-actions>
  </v-card>
</template>

<style scoped>
.deep-blue--text { color: #1B2559 !important; }

.dashboard-card {
  transition: all 0.3s ease;
  background: white !important;
}

.min-width-data {
  min-width: 80px;
  border: 1px solid #f0f0f0;
}

.chart-label {
  font-size: 7px;
  font-weight: 800;
  fill: #A3AED0;
}

svg {
  filter: drop-shadow(0px 8px 12px rgba(67, 24, 255, 0.1));
}
</style>

<script>
export default {
  name: "SparklineComponent",
  props: {
    etiquetas: { type: Array, default: () => [] },
    valores: { type: Array, default: () => [] },
    titulo: String,
    subtitulo: String,
    esMoneda: { type: Boolean, default: false } 
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Dialogos/SparklineComponent.vue